import React, { useState } from 'react'
import { Breadcrumb, Layout } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import {
  CardContainer,
  FormDropDown,
  FormInput,
  HeaderContainer,
  Loading,
  ModalDelete,
  Table
} from 'components'
import { Formik } from 'formik'
import { IcEdit, IcTrash } from 'assets/icons'
import { ModalCreateUpdateModel } from './components'
import { useQuery } from 'react-query'
import { apiDelete, apiGet, apiPost, apiPut, urls } from 'api'
import { useDispatch, useSelector } from 'react-redux'
import { metaInitialData, perPageInitialData } from 'constant'
import { logout } from 'store/actions'

const ProdukModelPage = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth)
  const [modelList, setModelList] = useState()
  const [meta, setMeta] = useState(metaInitialData)
  const [currentPage, setCurrentPage] = useState(0)
  const [dropDownBrandData, setdropDownBrandData] = useState([])
  const [perPageArr, setPerPageArr] = useState(perPageInitialData)

  const onLogout = () => dispatch(logout())

  const { isLoading, refetch } = useQuery({
    queryKey: ['model-list'],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await Promise.all([
        apiGet({
          url: `${urls.master.prefix}/${urls.master.products.model.root}?limit=${
            perPageArr.find((item) => item.selected === true).value
          }&offset=0`,
          token: user.token,
          onLogout
        }),
        apiGet({
          url: `${urls.master.prefix}/${urls.master.products.brand.all}`,
          token: user.token,
          onLogout
        })
      ]),
    onSuccess: (data) => {
      setdropDownBrandData([])
      setModelList(data[0].resData.data)
      if (data[1].resStatus === 200) {
        if (data[1].resData.data.length !== 0) {
          data[1].resData.data.map((item) => {
            setdropDownBrandData((prev) => [...prev, { name: item.name, value: item.id }])
          })
        }
      }
      setCurrentPage(0)
      setMeta(data[0].resData.meta)
    }
  })

  const [modalDelete, setModalDelete] = useState({
    status: false,
    modelId: 0,
    title: '',
    desc: ''
  })

  const [modalCreateUpdate, setModalCreateUpdate] = useState({
    status: false,
    type: 'create',
    modelId: 0,
    modelName: '',
    brandId: 0,
    brandName: ''
  })

  const [isLoadingCRUD, setIsLoadingCRUD] = useState(false)

  const [searchModel, setSearchModel] = useState('')
  const [selectedBrand, setSelectedBrand] = useState()

  const onHandleExtraUrl = () => {
    let extraUrl = ''

    if (searchModel !== '') {
      extraUrl += `&keywords=${searchModel}`
    }
    if (selectedBrand > 0) {
      extraUrl += `&brand_id=${selectedBrand}`
    }

    return extraUrl
  }

  const onChangePrevNextPage = (offset) => {
    setIsLoadingCRUD(true)
    setMeta({ ...meta, offset })
    const mount = setTimeout(async () => {
      const response = await apiGet({
        url: `${urls.master.prefix}/${urls.master.products.model.root}?limit=${
          perPageArr.find((item) => item.selected === true).value
        }&offset=${offset}${onHandleExtraUrl()}`,
        token: user.token,
        onLogout
      })
      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
        setModelList(response.resData.data)
      } else {
        refetch()
      }
      setIsLoadingCRUD(false)
    })
    return () => clearTimeout(mount)
  }

  const onChangePerPage = (value) => {
    setIsLoadingCRUD(true)
    const newArr = [...perPageArr]
    newArr.map((item) => {
      if (item.value === value) {
        item.selected = true
      } else {
        item.selected = false
      }
    })
    const mount = setTimeout(async () => {
      const response = await apiGet({
        url: `${urls.master.prefix}/${
          urls.master.products.model.root
        }?limit=${value}&offset=0${onHandleExtraUrl()}`,
        token: user.token,
        onLogout
      })
      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
        setModelList(response.resData.data)
        setMeta(response.resData.meta)
        setPerPageArr(newArr)
      } else {
        refetch()
      }
      setIsLoadingCRUD(false)
    })
    return () => clearTimeout(mount)
  }

  const columns = [
    {
      name: 'Model',
      selector: (row) => row.name,
      cell: (row) => <span className="font-medium text-gray-700">{row.name}</span>
    },
    {
      name: 'Brand',
      selector: (row) => row.brand.name,
      cell: (row) => <span className="font-medium text-gray-700">{row.brand.name}</span>
    },
    {
      name: 'Action',
      button: true,
      ignoreRowClick: true,
      sortable: false,
      right: true,
      center: true,
      width: '100px',
      cell: (row) => (
        <div className="flex items-center justify-center self-center">
          <div
            className="hover:cursor-pointer p-1 border-solid border border-gray-300 rounded-md mr-2 hover:bg-gray-100"
            onClick={() =>
              setModalCreateUpdate({
                type: 'edit',
                status: true,
                modelId: row.id,
                modelName: row.name,
                brandId: row.brand.id,
                brandName: row.brand.name
              })
            }>
            <IcEdit className="text-gray-700" size={16} />
          </div>
          <div
            className="hover:cursor-pointer p-1 border-solid border border-[#FDA19B] rounded-md hover:bg-gray-100"
            onClick={() =>
              setModalDelete({
                status: true,
                modelId: row.id,
                title: 'Hapus Model',
                desc: `Apakah anda yakin ingin menghapus model [${row.name}] ini? Data yang Anda Hapus tidak dapat dipulihkan kembali.`
              })
            }>
            <IcTrash className="text-primary-500" size={16} />
          </div>
        </div>
      )
    }
  ]

  if (isLoading ?? isLoadingCRUD) {
    return <Loading visible={true} />
  }

  return (
    <Layout
      style={{
        padding: 24,
        background: '#F5F5F5',
        width: '100%'
      }}>
      <Breadcrumb style={{ margin: 8 }}>
        <Breadcrumb.Item className="font-inter font-semibold text-gray-700">
          Master Data
        </Breadcrumb.Item>
        <Breadcrumb.Item className="font-inter font-medium text-gray-500">Produk</Breadcrumb.Item>
        <Breadcrumb.Item className="font-inter font-medium text-gray-500">Model</Breadcrumb.Item>
      </Breadcrumb>
      <Content style={{ margin: 8 }}>
        {modalCreateUpdate.status ? (
          <ModalCreateUpdateModel
            type={modalCreateUpdate.type}
            minHeight="min-h-[30%]"
            dataDropDown={dropDownBrandData}
            state={modalCreateUpdate}
            onClose={() => setModalCreateUpdate({ ...modalCreateUpdate, status: false })}
            onSubmit={(values) => {
              setIsLoadingCRUD(true)
              const mount = setTimeout(async () => {
                if (modalCreateUpdate.type === 'create') {
                  await apiPost({
                    url: `${urls.master.prefix}/${urls.master.products.model.root}`,
                    data: {
                      name: values.modelName,
                      brand_id: parseInt(values.brandSelector)
                    },
                    token: user.token,
                    onLogout
                  })
                }
                if (modalCreateUpdate.type === 'edit') {
                  await apiPut({
                    url: `${urls.master.prefix}/${urls.master.products.model.root}/${modalCreateUpdate.modelId}`,
                    data: {
                      name: values.modelName,
                      brand_id: parseInt(values.brandSelector)
                    },
                    token: user.token,
                    onLogout
                  })
                }
                setModalCreateUpdate({ ...modalCreateUpdate, status: false })
                setIsLoadingCRUD(false)
                refetch()
              })
              return () => clearTimeout(mount)
            }}
          />
        ) : null}
        {modalDelete.status ? (
          <ModalDelete
            minHeight="min-h-[20%]"
            minWidth="min-w-[22%]"
            maxWidth="max-w-[22%]"
            title={modalDelete.title}
            desc={modalDelete.desc}
            onClose={() => setModalDelete({ ...modalDelete, status: false })}
            onSubmit={() => {
              setIsLoadingCRUD(true)
              const mount = setTimeout(async () => {
                await apiDelete({
                  url: `${urls.master.prefix}/${urls.master.products.model.root}/${modalDelete.modelId}`,
                  token: user.token,
                  onLogout
                })
                setModalDelete({ ...modalDelete, status: false })
                refetch()
                setIsLoadingCRUD(false)
              })
              return () => clearTimeout(mount)
            }}
          />
        ) : null}
        <CardContainer minHeight="65%">
          <div className="flex flex-col w-full space-y-5">
            <HeaderContainer
              isPressAdd
              title="Model List"
              titleAdd="Tambah Model"
              onPressAdd={() => setModalCreateUpdate({ type: 'create', status: true })}
            />

            <div className="flex flex-row w-full items-center justify-between mt-2">
              <div className="w-1/6">
                <Formik
                  enableReinitialize
                  initialValues={{
                    brandSelector: selectedBrand
                  }}>
                  <FormDropDown
                    isSearch
                    allowClear
                    placeholder="Semua Brand"
                    name="brandSelector"
                    data={dropDownBrandData}
                    onChange={(value) => {
                      setIsLoadingCRUD(true)
                      let extraUrl = ''
                      const mount = setTimeout(async () => {
                        if (value) {
                          extraUrl = `&brand_id=${parseInt(value)}`
                        }
                        if (searchModel !== '') {
                          extraUrl += `&keywords=${searchModel}`
                        }
                        const response = await apiGet({
                          url: `${urls.master.prefix}/${urls.master.products.model.root}?limit=${
                            perPageArr.find((item) => item.selected === true).value
                          }&offset=0${extraUrl}`,
                          token: user.token,
                          onLogout
                        })
                        if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
                          setModelList(response.resData.data)
                          setMeta(response.resData.meta)
                        } else {
                          refetch()
                        }
                        setSelectedBrand(value ? parseInt(value) : null)
                        setIsLoadingCRUD(false)
                      })
                      return () => clearTimeout(mount)
                    }}
                  />
                </Formik>
              </div>
              <div className="w-1/5">
                <Formik
                  initialValues={{
                    searchModel: searchModel
                  }}>
                  <FormInput
                    name="searchModel"
                    placeholder="Pencarian"
                    type="text"
                    isIconLeft
                    iconName="search"
                    onValidate={async (value) => {
                      let extraUrl = ''
                      if (selectedBrand && selectedBrand > 0) {
                        extraUrl += `&brand_id=${selectedBrand}`
                      }
                      const response = await apiGet({
                        url: `${urls.master.prefix}/${
                          urls.master.products.model.root
                        }?keywords=${value}&limit=${
                          perPageArr.find((item) => item.selected === true).value
                        }&offset=0${extraUrl}`,
                        token: user.token,
                        onLogout
                      })
                      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
                        setModelList(response.resData.data)
                        setMeta(response.resData.meta)
                      } else {
                        refetch()
                      }
                      setSearchModel(value)
                    }}
                  />
                </Formik>
              </div>
            </div>
            <Table
              currentPage={meta.offset ? meta.offset + 1 : 1}
              totalPerPage={
                perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0) >
                meta.total
                  ? meta.total
                  : perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0)
              }
              dropDownDataFilter={perPageArr}
              lengthAllData={meta.total}
              columns={columns}
              data={modelList}
              onChangePrevPage={() => {
                if (currentPage > 0) {
                  setCurrentPage(currentPage - 1)
                  onChangePrevNextPage(
                    (currentPage - 1) * perPageArr.find((item) => item.selected === true).value
                  )
                }
              }}
              onChangeNextPage={() => {
                if (
                  perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0) <
                  meta.total
                ) {
                  setCurrentPage(currentPage + 1)
                  onChangePrevNextPage(
                    (currentPage + 1) * perPageArr.find((item) => item.selected === true).value
                  )
                }
              }}
              onChangeDropDown={(value) => onChangePerPage(value)}
            />
          </div>
        </CardContainer>
      </Content>
    </Layout>
  )
}

export default ProdukModelPage
